import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;
const data = {
  donationId: rootElement.getAttribute('donation-id') || false,
  consName: rootElement.getAttribute('cons-name') || false,
  eventName: rootElement.getAttribute('event-name') || false,
  teamName: rootElement.getAttribute('team-name') || false,
  campaign: rootElement.getAttribute('campaign') || false,
  type: rootElement.getAttribute('type') || false,
  teamId: rootElement.getAttribute('team-id') || false,
  frId: rootElement.getAttribute('fr-id') || false,
  diyType: rootElement.getAttribute('diy-type') || false
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App data={data}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
